import React, { useEffect } from "react";
import { Routes, Route, useLocation } from "react-router-dom";

import Home from "./screens/intro/Home";
import { AllLayout } from "./screens/AllLayout";
import DeliverySetting from "./screens/settings/DeliverySetting";
import Login from "./screens/intro/Login";
import { PrinterSettings } from "./screens/settings/PrinterSetting/PrinterSettings";
// import { initDeliverySetting } from "./recoil/delivery";
import SoundControl from "./components/SoundControl";

const App = () => {
  const location = useLocation();
  const background = location.state && location.state.background;

  useEffect(() => {
    // initDeliverySetting();
    SoundControl.playSilentSound();
    SoundControl.init();
  }, []);

  return (
    <>
      <Routes location={background || location}>
        <Route path="/" element={<AllLayout />}>
          <Route path="/" element={<Home />} />
          {/* DEV */}
          <Route path="/login/:id/:password/:uuid" element={<Login />} />
          <Route path="/printer" element={<PrinterSettings />} />
        </Route>
      </Routes>
      {background && (
        <Routes>
          <Route path="/delivery" element={<DeliverySetting />} />
        </Routes>
      )}
    </>
  );
};

export default App;
